import React from 'react';
import { Col, Form, InputGroup } from 'react-bootstrap';
import { IGroupAlerts, ISelectGroupState } from "../../../common/types/alertsTypes";
import { ITreeNode } from "../../../common/types/commonTypes";
import { SearchIcon } from "../../ui/icons";
import TreeView from "../../treeView";

interface IProps {
  handleGroupInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  groupSearchQuery: string,
  nodesToDisplay: ITreeNode[] ,
  handleDataFromTreeView: (selectedGroup: IGroupAlerts) => void,
  selectAllChecked: boolean,
  handleSelectAllChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  selectGroupState: ISelectGroupState,
  setSelectGroupState: React.Dispatch<React.SetStateAction<ISelectGroupState>>,
  groupsPlaceholder: string,
  checkedBox: string[]
}

const GroupSelectionFilter = (props: IProps) => {
  const {
    handleGroupInputChange,
    groupSearchQuery,
    nodesToDisplay,
    handleDataFromTreeView,
    selectAllChecked,
    handleSelectAllChange,
    selectGroupState,
    setSelectGroupState,
    groupsPlaceholder,
    checkedBox
  } = props;
  return (
    <Col sm={6}>
    <div className="select-group-container">
      <div className="send-alerts-group-content">
        <label className="heading">Send Alerts to Group(s)</label>
        <div className="alerts-search-and-tree">
          <div className="alert-search-input">
            <InputGroup>
              <Form.Control
                placeholder={groupsPlaceholder}
                aria-label="Search"
                aria-describedby="alert-search-input"
                value={groupSearchQuery}
                onChange={handleGroupInputChange}
              />
              <InputGroup.Text id="alert-search-input">
                <SearchIcon />
              </InputGroup.Text>
            </InputGroup>
          </div>
          <div className="alert-checkbox">
            <div className="select-all-checkbox">
              <Form>
                {["checkbox"].map((type) => (
                  <div key={type}>
                    <Form.Check
                      type="checkbox"
                      id="selectall"
                      label="Select All"
                      checked={selectAllChecked}
                      onChange={handleSelectAllChange}
                    />
                  </div>
                ))}
              </Form>
              <TreeView
                nodes={nodesToDisplay}
                onDataFromTreeView={handleDataFromTreeView}
                checkedBox={checkedBox}
                isModalOrg={true}
                isMultiSelect={true}
                selectGroupState={selectGroupState}
                setSelectGroupState={setSelectGroupState}
              ></TreeView>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Col>
  );
}

export default GroupSelectionFilter;